import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Login.css';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setBusy(true);
    const result = await login(username.trim(), password);
    setBusy(false);
    if (!result.success) setError(result.error);
  };

  return (
    <div className="login">
      <form className="login__box" onSubmit={handleSubmit}>
        <div className="login__logo">
          <span className="brand__mark brand__mark--lg" aria-hidden="true" />
          <h1>FlowTrack</h1>
          <span className="login__sub">RADIOLOGY WORKFLOW</span>
        </div>

        <div className="field">
          <label htmlFor="username">نام کاربری</label>
          <input
            id="username"
            name="username"
            type="text"
            autoComplete="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            required
            autoFocus
          />
        </div>

        <div className="field">
          <label htmlFor="password">رمز عبور</label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </div>

        {error && (
          <p className="login__error" role="alert">
            {error}
          </p>
        )}

        <button type="submit" className="btn btn--primary btn--block" disabled={busy}>
          {busy ? 'در حال ورود…' : 'ورود به سامانه'}
        </button>

        <p className="login__foot">
          زمان‌های گردش کار به‌صورت خودکار توسط سامانه ثبت می‌شوند
          <br />
          و قابل تغییر دستی نیستند.
        </p>
      </form>
    </div>
  );
}
